<div class="container-fluid">
  <div class="text-center">
    <div class="hello">
      <span>{{ 'Admin.welcome' | translate }}, {{ name }}</span>
    </div>
    <div class="d-flex justify-content-center flex-wrap">
      <ng-container *ngFor="let card of cards">
        <div class="card" (click)="openOnglet(card)" [matTooltip]="card.toolTip" *ngIf="userService.hasMenuAccess(card.text) ">
          <img [src]="card.logo" class="custom-image" />
          <span style="margin-top: 10px; text-wrap: nowrap;">{{ card.text | translate }}</span>
        </div>
      </ng-container>
    </div>
    
  <div class="container-fluid">
    <div class="line my-3"></div>
    <div class="row">
      <mat-tab-group class="mat-tab-group">
        <mat-tab [label]="adminTab.title">
          <app-tab-content [tab]="adminTab" style="display: block; height: inherit;"></app-tab-content>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>